export const compareDisplayName = (a, b) => {
  const aName = a.displayName.toUpperCase();
  const bName = b.displayName.toUpperCase();
  if (aName > bName) {
    return 1;
  }
  if (aName < bName) {
    return -1;
  }
  return 0;
};

export default {};



// WEBPACK FOOTER //
// ./src/main/data/utils.js